/*
Menu Desktop Scripts
*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dkt-level1__link').forEach((link, index) => {
    // Initiialize First Link
    if (index == 0) {
      link.style.color = '#3643BA';
    }

    link.addEventListener('mouseenter', () => {
      // Reset all links to their original color first
      document.querySelectorAll('.dkt-level1__link').forEach((otherLink) => {
        otherLink.style.color = ''; // Remove inline color style
      });

      // Set current link color
      link.style.color = '#3643BA';

      // Show/hide breadcrumbs
      document.querySelectorAll('.dkt-breadcrumbs-bar__block').forEach((item, i) => {
        item.style.display = i === index ? 'flex' : 'none';
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const breadcrumbsBar = document.querySelector('.dkt-breadcrumbs-bar');
  const containers = document.querySelectorAll('.dkt-subcategories-bar__container');
  const items = document.querySelectorAll('.dkt-breadcrumbs-bar__item');
  let currentContainer = null;

  function showContainer(key) {
    containers.forEach((container) => {
      container.style.display = container.getAttribute('data-key') === key ? 'flex' : 'none';
      if (container.getAttribute('data-key') === key) currentContainer = container;
    });
  }

  function hideAllContainers() {
    containers.forEach((container) => {
      container.style.display = 'none';
    });
    currentContainer = null;
    resetAllLinkColors();
  }

  function resetAllLinkColors() {
    items.forEach((item) => {
      const link = item.querySelector('a');
      if (link) {
        link.style.color = ''; // Reset to default/CSS color
      }
    });
  }

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      resetAllLinkColors();

      // Set active color for current item
      const link = item.querySelector('a');
      if (link) {
        link.style.color = '#3643BA';
      }
      const key = item.getAttribute('data-key');
      showContainer(key);
    });
  });

  function isHoveringOverBreadcrumbOrContainer() {
    return breadcrumbsBar.matches(':hover') || (currentContainer && currentContainer.matches(':hover'));
  }

  document.addEventListener('mousemove', () => {
    if (!isHoveringOverBreadcrumbOrContainer()) {
      hideAllContainers();
    }
  });
});

/*
Menu Mobile Scripts - Updated with Level2 Image Transitions
*/

window.onload = () => {
  const body = document.body;
  const hamburgerButton = document.getElementById('hamburgerButton');
  const menuMobile = document.getElementById('menuMobile');
  const sections = [
    document.getElementById('menuImage'),
    document.getElementById('menuTabs'),
    document.getElementById('menuNav'),
  ];

  let menuOpen = false;
  let currentActiveImage = null; // Track the currently active image

  async function showMenuWithAnimation() {
    menuMobile.style.display = 'block';
    menuMobile.style.backgroundColor = 'transparent';

    sections.forEach((section) => {
      section.style.display = 'block';
    });

    await new Promise(requestAnimationFrame);

    sections.forEach((section) => {
      section.classList.add('anim-in');
    });

    body.style.overflow = 'hidden';

    setTimeout(() => {
      menuMobile.style.backgroundColor = 'white';
    }, 500);

    isOpen = true;
  }

  function hideMenuWithAnimation() {
    menuMobile.style.backgroundColor = 'transparent';

    setTimeout(() => {
      startHideAnimation();
    }, 20);
  }

  function startHideAnimation() {
    sections.forEach((section) => {
      section.classList.remove('anim-in');
      section.classList.add('anim-out');
    });

    const lastSection = sections[sections.length - 1];
    lastSection.addEventListener(
      'animationend',
      () => {
        menuMobile.style.display = 'none';

        sections.forEach((section) => {
          section.classList.remove('anim-out');
          section.style.display = 'none';
        });

        body.style.overflow = 'auto';

        isOpen = false;
      },
      { once: true }
    );
  }

  hamburgerButton.addEventListener('click', () => {
    const isOpen = body.classList.toggle('menu-open');
    if (!menuOpen) {
      showMenuWithAnimation();
    } else {
      hideMenuWithAnimation();
    }
    menuOpen = !menuOpen;
  });

  let currentTabIndex = 0;

  // Function to transition images
  function transitionToImage(newImage, direction = 'right') {
    if (!newImage || newImage === currentActiveImage) return;

    const currentImg = currentActiveImage || document.querySelector('.dkt-menu-mobile__image-wrapper.active');

    if (currentImg && currentImg !== newImage) {
      // Remove active class and prepare for transition
      currentImg.classList.remove('active');
      currentImg.style.transform = `translateX(${direction === 'right' ? '-100%' : '100%'})`;
      currentImg.style.opacity = '0';

      // Setup new image
      newImage.style.display = 'block';
      newImage.style.transform = `translateX(${direction === 'right' ? '100%' : '-100%'})`;
      newImage.style.opacity = '0';
      newImage.classList.add('active');

      // Force reflow
      void newImage.offsetWidth;

      // Animate new image in
      newImage.style.transform = 'translateX(0)';
      newImage.style.opacity = '1';

      currentActiveImage = newImage;
    }
  }

  const label = document.getElementById('menuLabel');
  label?.addEventListener('click', () => {
    const labelText = label.textContent.trim();
    if (!labelText.startsWith('←')) return;

    // Hide all sub-blocks
    document.querySelectorAll('.dkt-menu-mobile__sub-block.active').forEach((sub) => {
      sub.classList.remove('active');
    });

    // Show the current tab's block
    const currentBlock = document.querySelector(`.dkt-menu-mobile__block[data-tab-index="${currentTabIndex}"]`);
    if (currentBlock) {
      currentBlock.classList.add('active');
    }

    // Restore tab image
    const tabImage = document.querySelector(
      `.dkt-menu-mobile__image-wrapper[data-tab-index="${currentTabIndex}"][data-tab-image="true"]`
    );
    if (tabImage) {
      transitionToImage(tabImage, 'left');
    }

    // Update label
    const level1Label = document
      .querySelector(`.tab-system .tab[data-tab-index="${currentTabIndex}"]`)
      ?.textContent?.trim();
    if (level1Label) {
      const outClass = 'menu-label-slide-out-left';
      const inClass = 'menu-label-slide-in-left';

      label.classList.remove('menu-label-slide-in-left', 'menu-label-slide-in-right');
      label.classList.add(outClass);

      setTimeout(() => {
        label.textContent = `Shop ${level1Label}`;
        label.classList.remove(outClass);
        label.classList.add(inClass);
      }, 150);
    }
  });

  document.getElementById('menuNav')?.addEventListener('updateMenuByTab', (event) => {
    const nextIndex = event.detail.tabIndex;
    const lists = document.querySelectorAll('.dkt-menu-mobile__block');
    const label = document.getElementById('menuLabel');

    document.querySelectorAll('.dkt-menu-mobile__sub-block.active').forEach((sub) => {
      sub.classList.remove('active');
    });

    if (nextIndex === currentTabIndex) return;

    const direction = nextIndex > currentTabIndex ? 'right' : 'left';

    const currentList = document.querySelector(`.dkt-menu-mobile__block[data-tab-index="${currentTabIndex}"]`);
    const nextList = document.querySelector(`.dkt-menu-mobile__block[data-tab-index="${nextIndex}"]`);

    nextList.classList.remove('slide-in-left', 'slide-in-right', 'slide-out-left', 'slide-out-right', 'active');
    nextList.classList.add(`slide-in-${direction}`);
    nextList.style.display = 'block';

    currentList.classList.remove('slide-in-left', 'slide-in-right', 'active');
    currentList.classList.add(`slide-out-${direction === 'right' ? 'left' : 'right'}`);

    setTimeout(() => {
      currentList.classList.remove(`slide-out-${direction === 'right' ? 'left' : 'right'}`);
      currentList.style.display = 'none';
      nextList.classList.remove(`slide-in-${direction}`);
      nextList.classList.add('active');
      currentTabIndex = nextIndex;
    }, 300);

    // Update label
    const tab = document.querySelector(`.tab-system .tab[data-tab-index="${nextIndex}"]`);
    if (tab && label) {
      const outClass = `menu-label-slide-out-${direction}`;
      const inClass = `menu-label-slide-in-${direction}`;

      label.classList.remove('menu-label-slide-in-left', 'menu-label-slide-in-right');
      label.classList.add(outClass);

      setTimeout(() => {
        label.textContent = 'Shop ' + tab.textContent.trim();
        label.classList.remove(outClass);
        label.classList.add(inClass);
      }, 150);
    }

    // Update image for tab change
    const nextImg = document.querySelector(
      `.dkt-menu-mobile__image-wrapper[data-tab-index="${nextIndex}"][data-tab-image="true"]`
    );
    if (nextImg) {
      transitionToImage(nextImg, direction);
    }
  });

  // Updated handler for level2 items with children
  document.querySelectorAll('.dkt-menu-mobile__block li[data-has-children="true"]').forEach((li) => {
    li.addEventListener('click', () => {
      const label = li.querySelector('.dkt-menu-mobile__label')?.textContent?.trim();
      const subId = li.getAttribute('data-sub-id');
      const subMenu = document.querySelector(`.dkt-menu-mobile__sub-block[data-id="${subId}"]`);
      if (!subMenu) return;

      console.log('Clicked on Level 2 with children:', label);

      // Check if there's an override image for this level2
      const hasOverrideImage = li.getAttribute('data-has-override-image') === 'true';
      if (hasOverrideImage) {
        const level2Image = document.querySelector(
          `.dkt-menu-mobile__image-wrapper[data-level2-image="true"][data-sub-id="${subId}"]`
        );
        if (level2Image) {
          transitionToImage(level2Image, 'right');
        }
      }

      // Update breadcrumb label
      const level1Label = document
        .querySelector(`.tab-system .tab[data-tab-index="${currentTabIndex}"]`)
        ?.textContent?.trim();
      if (label && level1Label && menuLabel) {
        const outClass = 'menu-label-slide-out-right';
        const inClass = 'menu-label-slide-in-right';

        menuLabel.classList.remove('menu-label-slide-in-left', 'menu-label-slide-in-right');
        menuLabel.classList.add(outClass);

        setTimeout(() => {
          menuLabel.textContent = `← ${level1Label} / ${label}`;
          menuLabel.classList.remove(outClass);
          menuLabel.classList.add(inClass);
        }, 150);
      }

      // Handle menu transitions
      document
        .querySelectorAll('.dkt-menu-mobile__block.active, .dkt-menu-mobile__sub-block.active')
        .forEach((el) => el.classList.remove('active'));

      const currentBlock = document.querySelector(`.dkt-menu-mobile__block[data-tab-index="${currentTabIndex}"]`);
      currentBlock.classList.remove('active');
      currentBlock.classList.add('slide-out-right');

      setTimeout(() => {
        currentBlock.classList.remove('slide-out-right');
      }, 300);

      subMenu.classList.remove('slide-in-right', 'slide-out-right', 'slide-out-left', 'active');
      subMenu.classList.add('slide-in-right');

      setTimeout(() => {
        subMenu.classList.remove('slide-in-right');
        subMenu.classList.add('active');
      }, 300);
    });
  });

  // Level3/4 expansion handlers
  document.querySelectorAll('.dkt-menu-mobile__sub-block .dkt-menu-mobile__item-inner').forEach((inner) => {
    const chevron = inner.querySelector('.dkt-menu-mobile__item-chevron');
    const submenu = inner.parentElement.querySelector('.dkt-menu-mobile__level4-list');

    if (chevron && submenu) {
      inner.addEventListener('click', (e) => {
        e.stopPropagation();

        const isOpen = submenu.classList.contains('open');

        document
          .querySelectorAll('.dkt-menu-mobile__sub-block .dkt-menu-mobile__level4-list.open')
          .forEach((openList) => {
            if (openList !== submenu) openList.classList.remove('open');
          });
        document
          .querySelectorAll('.dkt-menu-mobile__sub-block .dkt-menu-mobile__item-chevron.rotate')
          .forEach((rotated) => {
            if (rotated !== chevron) rotated.classList.remove('rotate');
          });

        submenu.classList.toggle('open', !isOpen);
        chevron.classList.toggle('rotate', !isOpen);
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const label = document.getElementById('menuLabel');
  const firstTab = document.querySelector('.tab-system .tab[data-tab-index="0"]');

  if (label && firstTab) {
    label.textContent = 'Shop ' + firstTab.textContent.trim();
  }

  // Set initial active image
  const firstImage = document.querySelector(
    '.dkt-menu-mobile__image-wrapper[data-tab-index="0"][data-tab-image="true"]'
  );
  if (firstImage) {
    currentActiveImage = firstImage;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tab-system .tab');
  const sections = document.querySelectorAll('.dkt-menu-mobile__section');
  const nav = document.getElementById('menuNav');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');

      const event = new CustomEvent('updateMenuByTab', {
        detail: { tabIndex: index },
      });
      nav.dispatchEvent(event);
    });
  });
});

/*
Cart Count Update
*/

function updateCartIcon() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const cartLinks = document.querySelectorAll('.dkt-header__cart');
      cartLinks.forEach((cartLink) => {
        const cartCountElements = cartLink.querySelectorAll('#CartCount, .dkt-header__cart-badge');

        cartCountElements.forEach((el) => {
          el.textContent = cart.item_count;
        });

        if (cart.item_count > 0) {
          cartLink.classList.add('has-items');
        } else {
          cartLink.classList.remove('has-items');
        }
      });
    });
}
